"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetWindowOriGenesysPlugin = void 0;
var _react = require("react");
var _webMessengerContext = require("../contexts/webMessengerContext");
// istanbul ignore next -- No need to test this function.
const emptyFunction = () => {};
// istanbul ignore next -- No need to test this function.
const nullFunction = () => null;

/**
 * Sets the OriGenesysPlugin object on the window object.
 * Object is used by chat-bot to communicate with WebMessenger and to open WebMessenger.
 */
const useSetWindowOriGenesysPlugin = () => {
  const {
    deploymentId,
    closeChatWindow,
    openChatWindow
  } = (0, _webMessengerContext.useWebMessenger)();
  (0, _react.useEffect)(() => {
    if (deploymentId && !window.oriGenesysPlugin) {
      const value = {
        ininChat: {
          clearUserData: emptyFunction,
          events: {
            CHAT_DISCONNECT: '',
            CLOSE: '',
            COMPLETE: '',
            INIT: '',
            OPEN_ERROR: '',
            READY: '',
            RECONNECT_FAILURE: '',
            subscribe: emptyFunction,
            unsubscribe: emptyFunction
          },
          getChatId: nullFunction,
          handleClose: closeChatWindow,
          iFrame: {
            load: openChatWindow
          },
          openChatWindow,
          popup: {
            close: emptyFunction,
            login: emptyFunction,
            minimize: emptyFunction,
            open: emptyFunction
          },
          server: {
            sendMessage: emptyFunction
          },
          toggle: emptyFunction,
          toggleVisibility: emptyFunction
        }
      };
      Object.defineProperty(window, 'oriGenesysPlugin', {
        writable: true,
        value
      });
    }
  }, [closeChatWindow, deploymentId, openChatWindow]);
};
exports.useSetWindowOriGenesysPlugin = useSetWindowOriGenesysPlugin;